import { StateCreator } from "zustand";

import { MediaDevicesSliceT } from "~/src/zustand/IMediaDevicesSlice";
import { StoreT } from "~/src/zustand/IZustand";

import { IMediaDevice } from "../../web-shared-components/react-components/calls/interfaces/IMediaDevice";

export const initialState = {
	cams: [],
	mics: [],
	speakers: []
};

export const createMediaDevicesSlice: StateCreator<
	StoreT,
	[["zustand/devtools", never], ["zustand/subscribeWithSelector", never]],
	[],
	MediaDevicesSliceT
> = (set) => ({
	...initialState,
	mediaDevicesSetAll: (mediaDevices) => {
		set(
			(prev) => {
				return {
					...prev,
					mediaDevices
				};
			},
			false,
			"mediaDevicesSetAll"
		);
	},
	mediaDevicesSetCams: (cams: IMediaDevice[]) => {
		set(
			(prev) => {
				return {
					...prev,
					cams
				};
			},
			false,
			"mediaDevicesSetCams"
		);
	},
	mediaDevicesSetMics: (mics: IMediaDevice[]) => {
		set(
			(prev) => {
				return {
					...prev,
					mics
				};
			},
			false,
			"mediaDevicesSetMics"
		);
	},
	mediaDevicesSetSpeakers: (speakers: IMediaDevice[]) => {
		set(
			(prev) => {
				return {
					...prev,
					speakers
				};
			},
			false,
			"mediaDevicesSetSpeakers"
		);
	}
});
